import Content from '@components/content';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import styles from './header.module.scss';

type THeaderProps = {
  children: React.ReactNode;
  className?: React.HTMLAttributes<HTMLElement>['className'];
  isPadding?: boolean;
};

export default function Header({
  children,
  className,
  isPadding = true,
}: THeaderProps) {
  return (
    <header
      className={`${className ? className : ''} ${styles.headerContainer}`}
    >
      {isPadding ? (
        <Content className="w-full h-full min-h-[60px] flex items-center py-[10px]">
          {children}
        </Content>
      ) : (
        <div>{children}</div>
      )}
    </header>
  );
}
